import api from "./axios";

const EndPoints = {
  wallexRates: `/merchant/market`,
  externalRates: `/merchant/market-setting/pairs`,
};

type WallexRateApi = {
  ticker: string;
  base: string;
  quote: string;
  buy: number;
  sell: number;
  minBuy?: number;
  minSell?: number;
  lastBuy?: number;
  lastSell?: number;
};

type WallexRatesResponse = {
  status: boolean;
  statusCode: number;
  message: string;
  data: WallexRateApi[];
};

type ExternalRateApi = {
  id: string;
  base: string;
  quote: string;
  minBuy?: number;
  minSell?: number;
  status?: boolean;
  buyRateProvider?: string;
  sellRateProvider?: string;
  buyRate?: number;
  sellRate?: number;
  strongerCurrency?: string;
  createdAt?: string;
  updatedAt?: string;
};

type ExternalRatesResponse = {
  status: boolean;
  statusCode: number;
  message: string;
  data: ExternalRateApi[];
};

export const getWallexRates = async () =>
  api.get<WallexRatesResponse>(EndPoints.wallexRates);

export const getExternalRates = async () =>
  api.get<ExternalRatesResponse>(EndPoints.externalRates);
